export default __webpack_public_path__ + "static/media/changeThumbnailIcon.145d2314.svg";